(function (angular, schoolwork12) {

	'use strict';
    angular.module(schoolwork12.app.administrationTools.name)
    .controller(schoolwork12.app.administrationTools.controllers.withdrawPerson, [
        '$rootScope', '$scope', '$http', '$timeout', '$interval', '$uibModal','$location',
         schoolwork12.app.auth.services.authentication,
    	 schoolwork12.app.administrationTools.services.withdrawPersonSvc,
	    function ($rootScope, $scope, $http, $timeout, $interval, $uibModal, $location, authentication, withdrawPersonSvc) {
        	
        	console.info("In withdraw person controller");
        	$scope.firstNameRequiredflag = false;
        	$scope.lastNameRequiredflag = false;
        	$scope.showSaveWithdrawPersonMsg = false;
        	$scope.showSaveErrorWithdrawPersonMsg=false;
        	
        	$scope.personIdRequired = 'Person ID is required when withdrawing a person. Please enter a value for this field.';
        	$scope.firstNameRequired = 'First Name is required when withdrawing a person. Please enter a value for this field.';
        	$scope.lastNameRequired = 'Last Name is required when withdrawing a person. Please enter a value for this field.';
        	
        	$scope.closeWithDrawSuccessSaveMsg = function() {
                $scope.showSavedWithdrawPersonMsg = false;
            }
        	
        	$scope.person={};
        	$scope.forms ={};
        	
        	$scope.submit = function (person) {
        		
        		console.info("In withdraw person controller submit function");
        		
        		$scope.showSaveErrorWithdrawPersonMsg = false;
        		$scope.showSaveWithdrawPersonMsg = false;
        		
        		if(typeof $scope.person.firstName === "undefined" || $scope.person.firstName == ''){
        			$scope.firstNameRequiredflag = true;
				} else $scope.firstNameRequiredflag = false;
        		
        		if(typeof $scope.person.lastName === "undefined" || $scope.person.lastName == ''){
        			$scope.lastNameRequiredflag = true;
				} else $scope.lastNameRequiredflag = false;
        		
        		if(typeof $scope.person.personId === "undefined" || $scope.person.personId == ''){
        			$scope.personIdRequiredflag = true;
				} else $scope.personIdRequiredflag = false;
        		
        		
        		if(!$scope.firstNameRequiredflag && !$scope.lastNameRequiredflag && !$scope.personIdRequiredflag)
    			{ 	  
        		withdrawPersonSvc.withdrawPerson(authentication.getCurrentUser().keycode, $scope.person).then(function (data) 
        				  {
    					console.info(data);
    					$scope.showSavedWithdrawPersonMsg = true;
    				},function(error) {
    					console.error('Error when withdrawing person...'.concat(angular.toJson(error)));
    					$scope.showSaveWithdrawPersonMsg = true;
    					$scope.showSaveErrorWithdrawPersonMsg=false;
    					$scope.adminToolSaveErrorMesg = "";
    					if (error.status == 400) {
    						$scope.showSaveWithdrawPersonMsg = false;
    						$scope.showSaveErrorWithdrawPersonMsg = true;
    						$scope.withdrawPersonError = error.data._errors[0];
    					} else if (error.status == 401 || error.status == 403) {
    						$scope.showSaveWithdrawPersonMsg = false;
    						$scope.showSaveErrorWithdrawPersonMsg = true;
    						$scope.withdrawPersonError = error.data._errors[0];
    					} else {
    						$scope.showSaveWithdrawPersonMsg = false;
    						$scope.showSaveErrorWithdrawPersonMsg = true;
    						$scope.withdrawPersonError = error.data._errors[0];
    					}
    				})['finally'](function () {
    					$scope.isAdminToolsSearchBusy = false;
    				});		
    			}
        		
        		
        		
        	}
        }
	]);

}(angular, schoolwork12));